<template>
  <div class="pages-css">
    <!-- top logo 语言切换 -->
    <div class="navbar-top">
      <img src="../assets/Logo Shapes 42.png" alt="" @click="goToFront" />
      <div class="navbar-top-title" @click="goToFront">
        <p>{{ $t("easyCareer") }}</p>
      </div>
      <div class="dropdown">
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            {{ lang }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="0">中文</el-dropdown-item>
            <el-dropdown-item command="1">日本語</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- navbar主体部分 -->
    <div class="navbar-main">
      <ul>
        <li
          v-for="(item, index) in navBarList"
          :key="index"
          @click="goToPages(item)"
        >
          <img :src="iconList[index]" alt="" /><span>{{
            lang === "CN" ? item.message : item.jPMessage
          }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { getRoleDir } from "../js/api";
import AES from "../js/AES";
import axios from "axios";
import locale from "element-ui/lib/locale"
import ja from "element-ui/lib/locale/lang/ja";
import zh from "element-ui/lib/locale/lang/zh-CN";
export default {
  name: "NavBar",
  components: {},
  data() {
    return {
      lang: "JP",
      navBarList: [],
      iconList: [
        require("../assets/Calendar.png"),
        require("../assets/ic_recruitment.png"),
        require("../assets/Building_04.png"),
        require("../assets/User_Square.png"),
        require("../assets/Chat_Dots.png"),
        require("../assets/Edit_Pencil_01.png"),
        require("../assets/3 User.png"),
        require("../assets/Calendar.png"),
        require("../assets/ic_recruitment.png"),
        require("../assets/Building_04.png"),
        require("../assets/User_Square.png"),
        require("../assets/Chat_Dots.png"),
        require("../assets/Edit_Pencil_01.png"),
        require("../assets/3 User.png"),
        require("../assets/Calendar.png"),
        require("../assets/ic_recruitment.png"),
        require("../assets/Building_04.png"),
        require("../assets/User_Square.png"),
        require("../assets/Chat_Dots.png"),
        require("../assets/Edit_Pencil_01.png"),
        require("../assets/3 User.png")
      ]
    };
  },
  created() {
  
    this.roleDir();

    // this.handleCommand('1')
  },
  computed: {},
  watch: {
    "$route.path": {
      handler(toPath, fromPath) {
        this.roleDir();
      },
      deep: true, // 深度监听
      immediate: true // 第一次初始化渲染就可以监听到
    }
  },
 
  methods: {
    //点击图片 切换首页
    goToFront() {
      var userInfo = localStorage.getItem("userInfo");
      const aesFecInfo = JSON.parse(AES.decrypt(userInfo));
      console.log(aesFecInfo);
      if (aesFecInfo.roleName === "adminuser") {
        this.$router.push("/adminFrontPage");
      } else if (
        aesFecInfo.roleName === "educationalinstitutionadmin" ||
        aesFecInfo.roleName === "educationalinstitutionuser"
      ) {
        this.$router.push("/educateIndex");
      } else if (
        aesFecInfo.roleName === "medicalinstitutionuser" ||
        aesFecInfo.roleName === "medicalinstitutionadmin"
      ) {
        this.$router.push("/medicalIndex");
      }
    },
    //切换语言
    handleCommand(command) {

      if (command === "0") {
         locale.use(zh);
        this.$i18n.locale = "zh-CN";
        this.lang = "CN";
        // this.roleDir();
        //储存语言状态z
        localStorage.setItem("language", this.lang);
      } else {
         locale.use(ja);
        this.$i18n.locale = "ja-JP";
        this.lang = "JP";
        // this.roleDir();
        //储存语言状态z
        localStorage.setItem("language", this.lang);
      }
    },
    //获取角色对应目录
    roleDir() {
      const fakeInfo = {
        token: localStorage.getItem("token")
      };
      getRoleDir(fakeInfo)
        .then(res => {
          console.log("-----获取目录接口-----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.navBarList = aesFecInfo;
            console.log(window.localStorage.getItem('language'))
            if((window.localStorage.getItem('language')==='CN')){
              this.handleCommand('0')
            }else{
              this.handleCommand('1')
            }
           this.lang=window.localStorage.getItem('language')
          }
        })
        .catch(res => {
          console.log("-----获取目录接口-----");
          console.log(res);
        });
    },
    //路由跳转
    goToPages(item) {
      this.$router.push(item.url);
    }
  }
};
</script>
<style scoped>
.pages-css {
  /* height: 100vh; */
  min-height: 100%;
  width: 266px;
  background: #51abff;
  min-height: 100vh;
}

.navbar-top {
  padding: 49px 0 70px 22px;
  display: flex;
}

.navbar-top-title {
  font-family: "Mochiy Pop One";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 35px;
  letter-spacing: -0.02em;
  color: #ffffff;
  margin-left: 5px;
  cursor: pointer;
}

.dropdown {
  margin-top: 15px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13.6333px;
  letter-spacing: 0.639063px;
  margin-left: 5px;
}

.el-dropdown-link {
  color: #ffffff;
}

.el-icon--right {
  color: #b9b9b9;
}

.navbar-main {
  background: #51abff;
  padding: 0 20px 0 40px;
  box-sizing: border-box;
}

.navbar-scroll {
  overflow-y: scroll;
  height: 700px;
  width: 280px;
  padding-right: 25px;
  box-sizing: border-box;
}

.navbar-main li {
  height: 70px;
  line-height: 70px;
  box-sizing: border-box;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  color: #ffffff;
  cursor: pointer;
}

.navbar-main li span {
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue